<script setup>
import { computed } from 'vue';

import Icon from 'dashboard/components-next/icon/Icon.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  empty: {
    type: Boolean,
    default: false,
  },
  query: {
    type: String,
    default: '',
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
  isFetching: {
    type: Boolean,
    default: true,
  },
  // A busca desta seção falhou (rede/servidor): mostra o erro com "Tentar de
  // novo" em vez de "nenhum resultado".
  hasError: {
    type: Boolean,
    default: false,
  },
  // Aviso fixo da seção (ex.: alcance da busca de mensagens).
  note: {
    type: String,
    default: '',
  },
  // Caminho alternativo quando a seção volta vazia.
  emptyHint: {
    type: String,
    default: '',
  },
});

defineEmits(['retry']);

const titleCase = computed(() => props.title.toLowerCase());
</script>

<template>
  <section class="mx-0 mb-3">
    <div
      v-if="showTitle"
      class="sticky top-0 pt-2 py-3 z-20 bg-gradient-to-b from-n-surface-1 from-80% to-transparent mb-3 -mx-1.5 px-1.5"
    >
      <h3 class="text-sm text-n-slate-11">{{ title }}</h3>
    </div>
    <p v-if="note" class="mt-0 mb-3 text-xs text-n-slate-11">
      {{ note }}
    </p>
    <slot />
    <woot-loading-state
      v-if="isFetching"
      :message="empty ? $t('SEARCH.SEARCHING_DATA') : $t('SEARCH.LOADING_DATA')"
    />
    <div
      v-if="hasError && !isFetching"
      role="alert"
      class="flex flex-col items-center justify-center gap-3 px-4 py-6 rounded-xl bg-n-slate-2 dark:bg-n-solid-1"
    >
      <p class="flex items-start gap-2 m-0 text-center text-n-slate-11">
        <Icon
          icon="i-ph-wifi-slash"
          class="text-n-ruby-11 size-4 flex-shrink-0 mt-[3px]"
        />
        {{ $t('SEARCH.LOAD_ERROR', { item: titleCase }) }}
      </p>
      <NextButton
        :label="$t('SEARCH.RETRY')"
        icon="i-ph-arrow-clockwise"
        slate
        sm
        faded
        @click="$emit('retry')"
      />
    </div>
    <div
      v-else-if="empty && !isFetching"
      class="flex flex-col items-center justify-center gap-2 px-4 py-6 rounded-xl bg-n-slate-2 dark:bg-n-solid-1"
    >
      <p class="flex items-start m-0 text-center text-n-slate-11">
        <Icon
          icon="i-ri-information-line"
          class="text-n-slate-11 size-4 flex-shrink-0 mt-[3px]"
        />
        <span class="mx-2">
          {{ $t('SEARCH.EMPTY_STATE', { item: titleCase, query }) }}
        </span>
      </p>
      <p v-if="emptyHint" class="m-0 text-sm text-center text-n-slate-11">
        {{ emptyHint }}
      </p>
    </div>
  </section>
</template>
